import { observer } from 'mobx-react-lite'

import { useApi } from '../../../hooks/storeHook'

import { MarketplacePricesSettings } from '../PricesSettings'
import { OzonPriceTypesMatching } from './OzonPriceTypesMatching'

import { OzonAccountProps } from '../../../types/accountProps'

export const OzonPricesSettings =
  observer(
    (props: OzonAccountProps) => {
      const {
        userSync: {setOzonPriceTypes, updatePricesOzon},
        prices: {enablePriceSyncOzon}
      } = useApi()

      return (
        <MarketplacePricesSettings
          {...props}
          onAddDefaultPrices={enablePriceSyncOzon}
          onForceUpdatePrices={updatePricesOzon}
          setPriceTypes={setOzonPriceTypes}
          PriceTypesMatchingComponent={OzonPriceTypesMatching}
        />
      )
    })